// @flow

// The agenda color class of a professional's dot (.agendaDoctorMark): the 15 colors, and the grey one for none or a
// color the dots don't have
export const doctorMarkColor = (color: any): string => {
  const number = Number(color);
  return `color-${Number.isInteger(number) && number >= 1 && number <= 15 ? number : 15}`;
};
